import { FormServicesAdminLayout, MenuLayout } from "../layouts";

export const CreateServicesPage = () => {
  return (
    <>
      <MenuLayout>
        <FormServicesAdminLayout />
      </MenuLayout>
    </>
  );
};
